// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ProfileAccount_tabs__1lqwo"};